import React, { useState,useEffect } from "react";
import { configData } from "../config";
import { useNavigate,useLocation ,useParams } from 'react-router-dom';
import Loading from './Loading';
import { Helmet } from 'react-helmet';
import SalespersonSidebar from './SalespersonSidebar';

const fetchedPackages = [
    { id: "1", name: 'Baseball Advanced Certificates' },
    { id: "2", name: 'Basketball Advanced Certificates'},
    { id: "3", name: 'Football Advanced Certificates'},
];

const DeleteProductPackage = () => {

    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const { id } = useParams(); 
    
    
    const initialPackageForm = {
        exe_package_name: ''
    }

    const [isLoading, setIsLoading] = useState(true); 
    const [formData, setFormData] = useState(initialPackageForm);
    const [errors, setErrors] = useState([]);
    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
        
    };

    useEffect(() => {
            Promise.all([
                retrievepackagedetailedview()
            ])
            .then(() => {
         
                setIsLoading(false);
            })
         
        },[]);

    async function  retrievepackagedetailedview() {
         
         
         const response = await fetch(
           app_url+'smwwcommerceproduct/getpackagedetailedview?id='+id,
           {
             method: "GET",
       
             headers: {
               'Content-Type': 'application/json',
             },
           }
         )
         const responsedata = await response.json();
         if(responsedata.data.msg == "Success") {
            
            const updatedForm = {
                exe_package_name: responsedata.data.result.name,
                id:id
            };
     
            setFormData(updatedForm);
    
         
         }
       
       }
    const handleDelete = async (e) => {
        e.preventDefault(); // prevent page reload

         const response = await fetch(app_url+'smwwcommerceproduct/deletepackagedetails', {
      method: 'POST',
      body: JSON.stringify(formData),
      headers: {
        'Content-Type': 'application/json',
      },
      });
      const data = await response.json();
      if(data.data.msg === "success") {
        navigate('/admin/smww-commerce/product-package-list', { state: { message: data.data.result } });
      }
      if(data.data.msg === "Error") {
        setErrors(data.data.result);
      }
    };

    return (
    <>
        {isLoading ? (
            <Loading />
        ) : (
        <div id="main">
            <Helmet><title>Delete Product Package</title></Helmet>
            <div className="left"></div>
            <div className="center left-center">
                {errors.length > 0 && (
                          <div 
                            className="set-message-error" 
                            style={{
                                    background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 8px no-repeat`,
                                    paddingLeft:"40px"
                                    }}>
                          {errors.map((item, index) => {
                          return <>{item}<br /></>
                          
                        })}  
                          </div>
                        )}
                <div>
                    <form>
                        <label>Executive Package Name <span className="form-required">*</span></label>
                        <input 
                            style={{width:"30%", marginBottom: "16px"}} 
                            type="text" 
                            name="exe_package_name" 
                            id="exe_package_name"
                            value={formData.exe_package_name}
                            onChange={handleChange}
                            required disabled 
                        />
                        <br />
                        <input 
                            type="button" 
                            id="edit-submit" 
                            name="" 
                            value="Delete Package"
                            onClick={handleDelete}
                            style={{width:"155px", height: "30px"}} 
                            className="form-submit" 
                        />
                    </form>
                </div>
            </div>
            <div className="right">
                <SalespersonSidebar />
            </div>
        </div>
        )}
    </>
    );

};
export default DeleteProductPackage;